import Vue from 'vue'

// 按需引入 Element UI 组件（babel-plugin-component 自动转换 import 为独立文件路径）
import {
  // Layout
  Container, Header, Aside, Main,
  // Basic
  Button, ButtonGroup,
  // Form
  Form, FormItem,
  Input, InputNumber,
  Radio, RadioGroup, RadioButton,
  Checkbox, CheckboxGroup, CheckboxButton,
  Select, Option, OptionGroup,
  Cascader,
  DatePicker,
  Switch, Slider,
  Upload,
  // Data
  Table, TableColumn,
  Tag, Progress, Tree, Badge, Pagination,
  // Notice
  Alert,
  // Navigation
  Menu, Submenu, MenuItem,
  Tabs, TabPane,
  Breadcrumb, BreadcrumbItem,
  Dropdown, DropdownMenu, DropdownItem,
  Steps, Step,
  // Others
  Dialog, Drawer,
  Tooltip, Popover,
  Card,
  Collapse, CollapseItem,
  Divider,
  Image, Link,
  Descriptions, DescriptionsItem,
  Empty, Skeleton, SkeletonItem,
  Timeline, TimelineItem,
  Row, Col
} from 'element-ui'

// Message / MessageBox / Notification 是服务（非组件），需特殊挂载
import { Message, MessageBox, Notification } from 'element-ui'

Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Button)
Vue.use(ButtonGroup)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(CheckboxButton)
Vue.use(Select)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Cascader)
Vue.use(DatePicker)
Vue.use(Switch)
Vue.use(Slider)
Vue.use(Upload)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Tag)
Vue.use(Progress)
Vue.use(Tree)
Vue.use(Badge)
Vue.use(Pagination)
Vue.use(Alert)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Dialog)
Vue.use(Drawer)
Vue.use(Tooltip)
Vue.use(Popover)
Vue.use(Card)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Divider)
Vue.use(Image)
Vue.use(Link)
Vue.use(Descriptions)
Vue.use(DescriptionsItem)
Vue.use(Empty)
Vue.use(Skeleton)
Vue.use(SkeletonItem)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Row)
Vue.use(Col)

// 全局服务
Vue.prototype.$message = Message
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification

// Loading 指令（v-loading / element-loading-text 等）
import { Loading } from 'element-ui'
Vue.use(Loading.directive)
Vue.prototype.$loading = Loading.service
